

import React from 'react'
// import ComingSoon from '../components/comingSoon';
import HireData from '../components/hire-data';
import Hireform from '../components/hire-form'
import usePageMeta from '../hooks/usePageMeta';
export default function Careers() {
    usePageMeta('Careers at Spinnennetz | Join Our Digital Team Now', 'Looking for a rewarding career in web development, design, or digital marketing? Join Spinnennetz and help us build cutting-edge digital solutions for clients.', '/careers', {"@context":"https://schema.org","@type":"WebPage","name":"Careers at Spinnennetz","description":"Join our dedicated team of web developers, designers, and CRO experts."});
    return (
        <>
            <HireData />
            <Hireform />
            {/* <ComingSoon /> */}
        </>
    );
}
